import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const marketplaceType = ["REDO", "OUTLET", "EBAY", "POSHMARK"] as const;
export type MarketplaceType = (typeof marketplaceType)[number];

const CatalogSchema_ = z.object({
  _id: zExt.objectId(),
  name: z.string(),
  description: z.string(),
  team: zExt.objectId(),
  status: z.string(),
  marketplaces: z.array(createEnum(marketplaceType)),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const CatalogSchema: z.ZodType<CatalogSchema> = CatalogSchema_;
export interface CatalogSchema extends z.infer<typeof CatalogSchema_> {}
